<template>
  <div v-if="info" class="myorder orderinfo">
      <div class="item">
        <div class="sitem ">
          <span class="tit">订单号：{{info.oid}}</span>
          <span v-if="info.status==0" class="status">待支付</span>
          <span v-if="info.status==1" class="status">已支付</span>
          <span v-if="info.status==2" class="status">待取件</span>
          <span v-if="info.status==3" class="status">待评价</span>
          <span v-if="info.status==4" class="status">已完成</span>
        </div>
        <div class="sitem topline">
          <div class="ovh">
            <div class="name storename fl">店名：{{info.store}}</div>
          </div>

          <p class="time">送洗时间：{{info.created_at}}</p>
        </div>

        <div v-for="(nv,nk) in info.noteArr" v-bind:key="nk" class="sitem sitem2 topline">
            <p v-for="(item,key) in cloth" v-bind:key="key" v-if="nv[key]">
              {{item}}：<span>{{nv[key]}}</span>
            </p>
            <!-- <p v-for="(item,key) in cloth2" v-bind:key="key" v-if="nv[key]">
              {{item}}：<span>{{nv[key]}}</span>
            </p> -->
        </div>

        <div v-if="info.status==0" class="total sitem  topline bottomline">
          <p>衣物件数：<span>{{info.clothNum}}件</span></p>
          <p>支付状态：<span>未付款</span></p>
          <p>合计金额：<span><span class="snum">{{info.price}}</span>元</span></p>
          <p v-if="pay_type==0">印章折扣：<span>-<span class="snum">{{info.minus}}</span>元</span></p>
          <p v-if="pay_type==1">团队折扣：<span>-<span class="snum">{{info.minus_company}}</span>元</span></p>
        </div>
        <div v-if="info.status==0" class="mt10 weui-cells weui-cells_checkbox">
            <label class="sitem weui-cell weui-check__label" for="s11">
                <div class="weui-cell__bd">
                    <p class="t-tit">个人余额：</p>
                    <p>可用余额：{{account.money.toFixed(2)}}</p>
                </div>
                <div class="weui-cell__hd">
                    <input v-model="pay_type" value="0" type="radio" class="weui-check" name="checkbox1" id="s11" :disabled="account.money<info.money">
                    <i class="weui-icon-checked"></i>
                </div>
            </label>
            <label v-if="account.is_company > 0" class="sitem weui-cell weui-check__label" for="s12">
                <div class="weui-cell__bd">
                    <p class="t-tit">团队余额：</p>
                    <p>可用余额：{{account.money_company.toFixed(2)}}</p>
                </div>
                <div class="weui-cell__hd">
                    <input v-model="pay_type" value="1" type="radio" name="checkbox1" class="weui-check" id="s12" :disabled="account.money_company<info.money">
                    <i class="weui-icon-checked"></i>
                </div>
            </label>
        </div>




        <div v-if="info.status==1 || info.status==2 || info.status==3 || info.status==4" class="total sitem  topline bottomline">
          <p>衣物件数：<span>{{info.clothNum}}件</span></p>
          <div class="ovh">
            <p>付款方式：<span v-if="info.pay_type == 0">余额支付</span><span v-if="info.pay_type == 1">单位余额支付</span></p>
            <p>合计金额：<span><span class="snum">{{info.price}}</span>元</span></p>
            <p v-if="info.pay_type == 0" class="fl">印章折扣：<span>-<span class="snum">{{info.minus}}</span>元</span></p>
            <p v-if="info.pay_type == 1" class="fl">团队折扣：<span>-<span class="snum">{{info.minus_company}}</span>元</span></p>
            <p class="fr">支付金额：<span>￥<span v-if="info.pay_type==0" class="num">{{info.money}}</span><span v-if="info.pay_type==1" class="num">{{info.money_company}}</span></span></p>
          </div>
        </div>


        <div v-if="info.status==3" class="otherform otherform2 weui-cells weui-cells_form">
            <div class="sitem weui-cells__title"><span>服务评价</span>如果满意，请给好评哦 ：）</div>
            <div class="sitem sitem6 weui-cell">
                <div class="weui-cell__bd">
                    <textarea v-model="cm_service" class="weui-textarea" placeholder="请输入服务评价" rows="5"></textarea>
                </div>
            </div>
        </div>

        <div v-if="info.status==4" class="otherform otherform2 weui-cells weui-cells_form">
            <div class="sitem weui-cells__title"><span>服务评价</span></div>
            <div class="sitem sitem6 weui-cell">
                <div class="weui-cell__bd">{{info.cm_service}}</div>
            </div>
        </div>


        <div v-if="info.status==3" class="otherform otherform2 weui-cells weui-cells_form">
            <!-- <div class="sitem weui-cells__title bigtit"><span>门店名称：{{info.store}}</span></div> -->
            <div class="sitem weui-cells__title"><span>门店评价</span>如果满意，请给好评哦 ：）</div>
            <div class="sitem sitem6 weui-cell">
                <div class="weui-cell__bd">
                    <textarea v-model="cm_store" class="weui-textarea" placeholder="请输入门店评价" rows="5"></textarea>
                </div>
            </div>
        </div>

        <div v-if="info.status==4" class="otherform otherform2 weui-cells weui-cells_form">
            <div class="sitem weui-cells__title"><span>门店评价</span></div>
            <div class="sitem sitem6 weui-cell">
                <div class="weui-cell__bd">{{info.cm_store}}</div>
            </div>
        </div>



        <div v-if="info.status==3" class="weui-cells star">
          <div class="sitem weui-cell">
            <span>干净：</span>
            <div class="weui-cell__bd">
              <i v-for="(v,k) in 5" v-bind:key="k" class="s" :class="[v<=cm_star_clean?'cur':'']" @click="dealClean(v)"></i>
            </div>
          </div>
          <div class="sitem weui-cell">
            <span>整洁：</span>
            <div class="weui-cell__bd">
              <i v-for="(v,k) in 5" v-bind:key="k" class="s" :class="[v<=cm_star_neat?'cur':'']" @click="dealNeat(v)"></i>
            </div>
          </div>
          <div class="sitem weui-cell">
            <span>服务：</span>
            <div class="weui-cell__bd">
              <i v-for="(v,k) in 5" v-bind:key="k" class="s" :class="[v<=cm_star_service?'cur':'']" @click="dealService(v)"></i>
            </div>
          </div>
          <div class="sitem weui-cell">
            <span>及时：</span>
            <div class="weui-cell__bd">
              <i v-for="(v,k) in 5" v-bind:key="k" class="s" :class="[v<=cm_star_speed?'cur':'']" @click="dealSpeed(v)"></i>
            </div>
          </div>

        </div>

        <div v-if="info.status==4" class="weui-cells star">
          <div class="sitem weui-cell">
            <span>干净：</span>
            <div class="weui-cell__bd">
              <i v-for="(v,k) in 5" v-bind:key="k" class="s" :class="[v<=info.cm_star_clean?'cur':'']"></i>
            </div>
          </div>
          <div class="sitem weui-cell">
            <span>整洁：</span>
            <div class="weui-cell__bd">
              <i v-for="(v,k) in 5" v-bind:key="k" class="s" :class="[v<=info.cm_star_neat?'cur':'']"></i>
            </div>
          </div>
          <div class="sitem weui-cell">
            <span>服务：</span>
            <div class="weui-cell__bd">
              <i v-for="(v,k) in 5" v-bind:key="k" class="s" :class="[v<=info.cm_star_service?'cur':'']"></i>
            </div>
          </div>
          <div class="sitem weui-cell">
            <span>及时：</span>
            <div class="weui-cell__bd">
              <i v-for="(v,k) in 5" v-bind:key="k" class="s" :class="[v<=info.cm_star_speed?'cur':'']"></i>
            </div>
          </div>
        </div>
        <div v-if="info.status==2" class="app-btn-area weui-btn-area">
            <div @click="orderGet()" class="weui-btn">确认收货</div>
        </div>
        <div v-if="info.status==3" class="app-btn-area weui-btn-area">
            <div @click="orderComment()" class="weui-btn">提交评价</div>
        </div>

      </div>
      <div v-if="info.status==0" class="order-foot">
        <div class="fll">合计金额：￥ <span v-if="pay_type==0">{{info.money.toFixed(2)}}</span><span v-if="pay_type==1">{{info.money_company.toFixed(2)}}</span></div>
        <div @click="orderpay()" class="bbtn">支付订单</div>
      </div>
  </div>
</template>

<script>
export default {
  data(){
    return{
      account:{money:0.00,money_company:0.00},
      cloth:{
        "clothesno": "衣物编号",
        "clothesname": "衣物名称",
        "clothescolor": "颜色",
        "washtype": "洗涤方式",
        "clothesje": "金额",
        "clothesssje": "实收金额",
        "brand": "衣物品牌",
        "clothesstatus": "衣物状态",
        "attachment": "衣物附件",
        "note": "备注",
        "requirement": "客人要求",
        "additional": "附加要求",
        "additional_price": "附加价格"
      },
      cloth2:{
        "clothesstatus": "衣物状态",
        "attachment": "衣物附件",
        "note": "备注",
        "requirement": "客人要求",
        "additional": "附加要求",
        "additional_price": "附加价格"
      },
      id:0,
      oid:'',
      info:null,
      pay_type:'',
      cm_service:'',
      cm_store:'',
      cm_star_clean:0,
      cm_star_neat:0,
      cm_star_service:0,
      cm_star_speed:0
    }
  },
  mounted(){
    this.id = this.$route.query.id;
    this.oid = this.$route.query.oid;
    this.getOrderInfo();
  },
  methods:{
    getAccount(){
      let vm = this;
      vm.ajax("account", "get", '', e => {
        vm.account = e.data;
        if(vm.account.money >= vm.info.money){
          vm.pay_type = 0
        }else if(vm.account.is_company > 0 && vm.account.money_company >= vm.info.money){
          vm.pay_type = 1
        }
      })
    },
    getOrderInfo(){
      let vm = this;
      vm.ajax("account/order/info", "get", 'order_id='+vm.oid, e => {
        let info = e.data;
        info.clothNum = 0;
        if(info.note){
          try {
            info.noteArr = JSON.parse(info.note);
            info.clothNum = info.noteArr.length;
          } catch (error) {

          }
        }
        info.minus = (info.price-info.money).toFixed(2);
        info.minus_company = (info.price-info.money_company).toFixed(2);
        vm.info = info;
        vm.getAccount();
      })
    },
    orderpay(){
      let vm = this;
      vm.pay_type = vm.pay_type*1;
      if( !(vm.pay_type >= 0)){
        // vm.publics.message.danger('余额不足请充值');
        // setTimeout(function(){
        vm.$router.replace('/recharge')
        // },2000)
        return false;
      }
      vm.ajax("account/order/pay", "post", {
        order_id:vm.oid,
        pay_type:vm.pay_type
      }, e => {
        vm.getOrderInfo();
      })
    },
    orderGet(){
      let vm = this;
      vm.ajax("account/order/get", "post", {
        order_id:vm.oid
      }, e => {
        vm.getOrderInfo();
      })
    },
    dealClean(v){
      this.cm_star_clean = v;
    },
    dealNeat(v){
      this.cm_star_neat = v;
    },
    dealService(v){
      this.cm_star_service = v;
    },
    dealSpeed(v){
      this.cm_star_speed = v;
    },
    orderComment(){
      let vm = this;
      // if(!vm.cm_service){
      //   vm.publics.message.danger('请输入服务评价，不少于8个字');
      //   return false;
      // }
      // if(!vm.cm_store){
      //   vm.publics.message.danger('请输入门店评价，不少于8个字');
      //   return false;
      // }
      if(vm.cm_star_clean<=0){
        vm.publics.message.danger('请对干净度进行评分');
        return false;
      }
      if(vm.cm_star_neat<=0){
        vm.publics.message.danger('请对整洁度进行评分');
        return false;
      }
      if(vm.cm_star_service<=0){
        vm.publics.message.danger('请对服务进行评分');
        return false;
      }
      if(vm.cm_star_speed<=0){
        vm.publics.message.danger('请对速度进行评分');
        return false;
      }
      vm.ajax("account/order/comment", "post", {
        order_id:vm.oid,
        cm_service:vm.cm_service,
        cm_store:vm.cm_store,
        cm_star_clean:vm.cm_star_clean,
        cm_star_neat:vm.cm_star_neat,
        cm_star_service:vm.cm_star_service,
        cm_star_speed:vm.cm_star_speed
      }, e => {
        vm.getOrderInfo();
      })
    }
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/orderinfo.vue